import { combineReducers } from 'redux';
import uploadReducer from './uploadReducer';
import authReducer from './authReducer';
export default combineReducers({
    uploadReducer,
    authReducer
});